import React from "react";

const SupportChat = React.lazy(() => import('src/pages/support_chat/SupportChat'));

const routes = [
    { path: '/dashboard/support-tickets', name: 'Support Tickets', element: SupportChat },
];

export default routes;
